import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Autocomplete, TextField, useTheme } from '@mui/material';
import { useUserAuth } from '../providers/auth';
import {
  OrganizationAccountsQuery,
  OrganizationAccountsQueryVariables,
} from 'common/build/src/graphql/__generated__/operations';

const accountSearchQuery = gql`
  query OrganizationAccounts($id: ID!) {
    organization(id: $id) {
      id
      accounts {
        id
        name
      }
    }
  }
`;

interface Account {
  id: string;
  name: string;
}

interface AccountAutocompleteProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  disabled?: boolean;
  name?: string;
  size?: 'small' | 'medium';
  required?: boolean;
  forceValidate?: boolean;
}

export const AccountAutocomplete = ({
  value,
  onChange,
  label = 'Account',
  disabled = false,
  name = 'account',
  size = 'medium',
  required = false,
  forceValidate = false,
}: AccountAutocompleteProps) => {
  const theme = useTheme();
  const { user } = useUserAuth();
  const organizationId = user?.organizationId;
  const variables = { id: organizationId || '' };
  const skip = !organizationId;
  const { data } = useQuery<
    OrganizationAccountsQuery,
    OrganizationAccountsQueryVariables
  >(accountSearchQuery, {
    variables,
    skip,
  });
  const accounts = data?.organization?.accounts || [];
  const options = accounts.map((account: Account) => account.name);
  return (
    <Autocomplete
      id="account-input"
      freeSolo
      autoComplete
      value={value}
      size={size}
      disabled={disabled}
      fullWidth
      options={options}
      onChange={(e, val) => {
        onChange(val || '');
      }}
      renderInput={(params) => (
        <TextField
          label={label}
          required={required}
          name={name}
          error={forceValidate && required}
          onChange={(e) => {
            onChange(e.target.value);
          }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...params}
        />
      )}
      sx={{
        '& .MuiAutocomplete-listbox': {
          zIndex: theme.zIndex.modal + 100,
        },
      }}
    />
  );
};
